import _ from 'lodash';
import moment from 'moment';

import { format } from '@breezeway/brzw-react-core';
import { DIFF_TIME_FORMAT } from './date_time';

/**
 * @param {String} history - history from the response
 * @return {Array} returns array of history elements sorted by dates
 */
// eslint-disable-next-line import/prefer-default-export
export const getSortedHistory = history => {
  const sortedHistory = _.sortBy(history, element => _.get(element, 'context.event_time'));

  let currentDate = moment();
  let resultArray = [];
  let elementsArray = [];

  _.forEach(_.reverse(sortedHistory), element => {
    const eventTime = _.get(element, 'context.event_time');
    const formattedTime = format.datetime.formatDateTime(eventTime, true, DIFF_TIME_FORMAT);
    const time = moment(formattedTime, DIFF_TIME_FORMAT);
    if (currentDate.isSame(time, 'day')) {
      elementsArray = [...elementsArray, element];
    } else {
      resultArray = [...resultArray, { date: currentDate, elements: elementsArray }];
      currentDate = time;
      elementsArray = [element];
    }
  });

  resultArray = [...resultArray, { date: currentDate, elements: elementsArray }];

  return resultArray;
};
